import { render, staticRenderFns } from "./AppointmentTableItem.vue?vue&type=template&id=0a95b3e6"
import script from "./AppointmentTableItem.vue?vue&type=script&lang=js"
export * from "./AppointmentTableItem.vue?vue&type=script&lang=js"
import style0 from "./AppointmentTableItem.vue?vue&type=style&index=0&id=0a95b3e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports